import { Link } from "react-router-dom";
import "./Button.css";

const Button = ({
	children,
	variant = "primary",
	to,
	onClick,
	type = "button",
	className = "",
}) => {
	const classNames = `button ${variant} ${className}`;

	if (to) {
		return (
			<Link to={to} className={classNames}>
				{children}
			</Link>
		);
	}

	return (
		<button className={classNames} onClick={onClick} type={type}>
			{children}
		</button>
	);
};

export default Button;
